// Add all API URLs to URLStore object
// A complete URL consists of baseURL + API endpoint

import { environment } from '../../environments/environment';

const baseURL = environment.baseURL;
const baseAgentUrl = environment.baseAgentUrl;

export const URLStore = {
  localOAuthURL: `${baseURL}/api/account/{accountId}/localoauth`,
  blsAccounts: {
    getURL: `${baseURL}/api/account`,
  },
  getGbpLocationGroups: `${baseURL}/api/account/{accountId}/gbplocationgroups`,
  // location data for dropdowns
  accessibleLocations: `${baseURL}/api/user/access/locations`,
  // accessible location groups and roles for the user pop-up
  accessibleLocationGroups: `${baseURL}/api/account/{accountId}/available/location-groups`,
  accessibleUserRoles: `${baseURL}/api/available/user-roles`,
  location: {
    exportLocations:
        `${baseURL}/api/account/{accountId}/locations/export`,
    getLocations: `${baseURL}/api/account/{accountId}/locations/all`,
    getLocationIdsWithUpdates:
        `${baseURL}/api/account/{accountId}/locations/filter`,
    getCountersURL: `${baseURL}/api/account/{accountId}/counters`,
    uploadURL:
        `${baseURL}/api/account/{accountId}/upload`,
    exportDuplicatesURL:
        `${baseURL}/api/account/{accountId}/exportDuplicates`,
    exportStarredCCSearchResultsURL:
        `${baseURL}/api/account/{accountId}/exportStarredResults`,
    exportPlaceNamesURL:
        `${baseURL}/api/account/{accountId}/placenames`,
    exportLocationDifferencesURL:
        `${baseURL}/api/account/{accountId}/differences/export`,
    archiveURL:
        `${baseURL}/api/account/{accountId}/locations/archive`,
    editInBlsURL:
        `${baseURL}/api/account/{accountId}/locations/{locationId}`,
    getUpdatesURL:
        `${baseURL}/api/account/{accountId}/locations/{locationId}/updates`,
    patchGMBLocationsURL:
        `${baseURL}/api/account/{accountId}/locations/patch`,
    editGMBConnectionURL:
        `${baseURL}/api/account/{accountId}/locations/{locationId}/mybusiness/{command}`,
    refreshGMBConnectionURL:
        `${baseURL}/api/account/{accountId}/locations/mybusiness/refresh`,
    updateDifferencesAndPatchGMBLocationURL:
        `${baseURL}/api/account/{accountId}/locations/{locationId}/updateDifferencesAndPatchGMBLocation`,
    bulkEditDifferenceAcceptanceURL:
        `${baseURL}/api/account/{accountId}/locations/bulkdifferences`,
    blacklistFieldsURL:
        `${baseURL}/api/account/{accountId}/locations/blacklist`,
    getLocationCountsURL:
        `${baseURL}/api/account/{accountId}/locations/counts`,
    getLocationsCountURL:
        `${baseURL}/api/account/{accountId}/locations/count`,
    bulkEditLocationGroupsURL: `${baseURL}/api/account/{accountId}/locations/bulkEditLocationGroups`,
    claimAndClean: {
      searchForGoogleMapsMatchesURL: `${baseURL}/api/account/{accountId}/locations/{locationId}/searchForGoogleMapsMatches`,
      ccMatrixURL: `${baseURL}/api/account/{accountId}/ccMatrix`,
      claimGoogleMapsMatchURL: `${baseURL}/api/account/{accountId}/locations/{locationId}/claimAndLinkGoogleMapsMatch`,
      undoClaimAndLinkGoogleMapsMatch: `${baseURL}/api/account/{accountId}/locations/{locationId}/undoClaimAndLinkGoogleMapsMatch`,
      claimGoogleMapsMatchAsDuplicateURL: `${baseURL}/api/account/{accountId}/locations/{locationId}/claimGoogleMapsMatchAsDuplicate`,
      undoClaimGoogleMapsMatchAsDuplicate: `${baseURL}/api/account/{accountId}/locations/{locationId}/undoClaimGoogleMapsMatchAsDuplicate`,
      starGoogleMapsMatchURL: `${baseURL}/api/account/{accountId}/locations/{locationId}/starGoogleMapsMatch`,
      markParentAsCompletedURL: `${baseURL}/api/account/{accountId}/locations/{locationId}/markLocationAsCompleted`,
      keywordsURL: `${baseURL}/api/account/{accountId}/claimingKeywords`,
      radiusURL: `${baseURL}/api/account/{accountId}/searchRadius`,
      claimingTargetLocationGroup: `${baseURL}/api/account/{accountId}/claimingTargetLocationGroupId`,
    },
    verifyCoordinates: `${baseURL}/api/account/{accountId}/locations/{locationId}/verify`,
    bulkVerify: `${baseURL}/api/job/bulk-coordinates/{accountId}/schedule`,
    bulkVerifyStatus: `${baseURL}/api/account/{accountId}/bulk-progress`,
    getCoordinateHistory: `${baseURL}/api/pin-validation/locations/{locationId}`,
    getLastValidationSrc: `${baseURL}/api/pin-validation/latest-location/{locationId}`,
    columnNotes: {
      postURL: `${baseURL}/api/accounts/{accountId}/columnnotes`,
      getURL: `${baseURL}/api/accounts/{accountId}/columnnotes/{columnName}`,
      getAllURL: `${baseURL}/api/accounts/{accountId}/columnnotes`,
      putURL: `${baseURL}/api/accounts/{accountId}/columnnotes/{columnNoteId}`,
      deleteURL: `${baseURL}/api/accounts/{accountId}/columnnotes/{columnNoteId}`,
    },
    dataSourceConfig: `${baseURL}/api/accounts/{accountId}/dataSourceConfig`,
    countrySet: `${baseURL}/api/account/{accountId}/locations/countryset`,
    datasourceSyncDetails: `${baseURL}/api/datasource/{accountId}/details`,
    restartDatasourceSync: `${baseURL}/api/datasource/{accountId}/restart`,
    getPlacesApiSyncStatus: `${baseURL}/api/account/{accountId}/placesApiSyncStatus`,
    syncPlacesApi: `${baseURL}/api/account/{accountId}/user/scheduleSearchesForGoogleMapsMatches`,
  },
  photo: {
    getUrl: `${baseURL}/api/photo/get`,
  },
  review: {
    templatesURL: `${baseURL}/api/accounts/{accountId}/replytemplates`,
    countrySelectionList: `${baseURL}/api/accounts/{accountId}/reviews/getCountrySelectionList`,
    generateReply: `${baseURL}/api/accounts/{accountId}/reviews/{reviewId}/generateReviewReply`,
    aiSettings: `${baseURL}/api/accounts/{accountId}/reviews/settings`,
    defaultLanguage: `${baseURL}/api/accounts/{accountId}/reviews/settings/language`, // GET / PUT
    replyStyle: `${baseURL}/api/accounts/{accountId}/reviews/settings/style`, // PUT

    // new rep service endpoints
    getReviews: `${baseURL}/api/reputation/reviews/search`,
    translate: `${baseURL}/api/reputation/translate/review/{reviewId}`, // POST
    reply: `${baseURL}/api/reputation/reviews/{reviewId}/reply`, // POST / DELETE
    analytics: `${baseURL}/api/reputation/reviews/{reviewId}/reply/analytics`,
    flag: `${baseURL}/api/reputation/reviews/{reviewId}/flag`,
    syncLocationReviews: `${baseURL}/api/reputation/location/{storeCode}/reviews-sync`, // sync all reviews per location
    downloadReviews: `${baseURL}/api/reputation/reviews-download`,
  },
  questions: {
    getURL: `${baseURL}/api/reputation/questions/search`,
    countURL: `${baseURL}/api/reputation/questions/count`,
    answerURL:
        `${baseURL}/api/reputation/questions/{lscQuestionId}/answer`,
    deleteAnswerURL:
        `${baseURL}/api/accounts/{accountId}/qanda/answer/{answerId}/delete`,
  },
  insights: {
    reviews: `${baseURL}/api/accounts/{accountId}/insights/reviews/{method}`,
    preflight: `${baseAgentUrl}/preflight`,
    chat: `${baseAgentUrl}/chat`,
    chatSuggestions: `${baseAgentUrl}/chat/suggestions`,
    feedback: `${baseAgentUrl}/chat/feedback`,
    sessions: `${baseAgentUrl}/sessions`,
    session: `${baseAgentUrl}/sessions/{sessionId}`,
    renameSession: `${baseAgentUrl}/sessions/{sessionId}/rename`,
    deleteSession: `${baseAgentUrl}/sessions/{sessionId}`,
  },
  users: {
    // gbp users
    group: `${baseURL}/api/accounts/{accountId}/admins/accounts`,
    single: `${baseURL}/api/accounts/{accountId}/admins/locations`,
    // NEW USER MNGMNT
    // user profiles
    getUsers: `${baseURL}/api/account/{accountId}/users`,
    // additional info not present in ID token such as permissions and role
    getUserDetails: `${baseURL}/api/users/self/details`,
    createUser: `${baseURL}/api/account/{accountId}/users/invite`,
    editOrDeleteUser: `${baseURL}/api/account/{accountId}/users/{userId}`,
    resendInvitation: `${baseURL}/api/users/{userId}/resend`,
    changeLanguage: `${baseURL}/api/users/language`,
  },
  feedback: `${baseURL}/api/feedback`,
  translate: {
    difference:
        `${baseURL}/api/translate/differences`,
    locationAddress: `${baseURL}/api/translate/location/{locationId}`,

  },
  emailNotificationSettings: `${baseURL}/api/user/notification-settings`, // GET / PUT
  campaigns: {
    getCampaigns: `${baseURL}/api/campaign/list`,
    getPosts: `${baseURL}/api/campaign/{campaignId}/campaign-posts`,
    editCampaign: `${baseURL}/api/campaign/{campaignId}`,
    deleteCampaign: `${baseURL}/api/campaign/{campaignId}`,
    archiveCampaign: `${baseURL}/api/campaign/{campaignId}/archive`,
    createCampaign: `${baseURL}/api/campaign`,
    getClientTokens: `${baseURL}/api/campaign/client/token`,
    setClientTokens: `${baseURL}/api/campaign/client/token/upsert`,
    // social media
    getPlatforms: `${baseURL}/api/campaign/social-media/accounts`,
    connectPlatform: `${baseURL}/api/campaign/social-media/account/connect`,
    disconnectPlatform: `${baseURL}/api/campaign/social-media/accounts/{id}`,
    getSocialMediaPosts: `${baseURL}/api/campaign/social-media/campaign/{campaignId}/posts`,
    getValidationRules: `${baseURL}/api/campaign/social-media/supported`,
  },
  jasoner: `${baseURL}/api/jasoner-magic-link`,
};
